import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Signup.css';
import { FaCheck, FaArrowLeft } from 'react-icons/fa';
import { FiArrowRight } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const marketData = {
  Grains: {
    subMarkets: ['Wheat', 'Rice', 'Maize', 'Barley', 'Sorghum', 'Millet'],
    packages: {
      'Platinum+': ['All in Platinum +', 'Download Historical Prices of last 5 years', 'Download Statistics Data of last 5 years', 'Excel Plug-in & API', 'Tender Listing', 'Customized Dashboard', 'Mobile APP (Professional)'],
      'Platinum': ['All in Gold +', 'Download Historical Prices of last 2 years', 'Download Statistics Data of last 2 years', 'Mobile APP (Professional)'],
      'Gold': ['All in Silver +', 'Statistics Graphical View', 'Logistics - Vessel Line-up', 'Ad-on Special Reports', 'Mobile APP (Professional)'],
      'Silver': ['Prices', 'Insights', 'Intel', 'Tenders', 'Price Graph view with compare feature', 'Regular Reports'],
    }
  },
  Oilseeds: { subMarkets: ['Soybean', 'Rapeseed', 'Sunflower', 'Groundnut', 'Palm Oil'], packages: { 'Platinum+': ['...'], 'Platinum': ['...'], 'Gold': ['...'], 'Silver': ['...'] } },
  Pulses: { subMarkets: ['Bengal Gram', 'Urad Dal', 'Moong', 'Masoor', 'Tur'], packages: { 'Platinum+': ['...'], 'Platinum': ['...'], 'Gold': ['...'], 'Silver': ['...'] } },
  Spices: { subMarkets: ['Chilli', 'Turmeric', 'Coriander', 'Cumin', 'Cardamom'], packages: { 'Platinum+': ['...'], 'Platinum': ['...'], 'Gold': ['...'], 'Silver': ['...'] } },
};

const Signup = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [activeMarket, setActiveMarket] = useState('Grains');
  const [activeSubMarket, setActiveSubMarket] = useState(marketData['Grains'].subMarkets[0]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [contactMethod, setContactMethod] = useState('Email');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState('');
  const [otpError, setOtpError] = useState('');
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [fullName, setFullName] = useState('');
  const [jobTitle, setJobTitle] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [companyType, setCompanyType] = useState('');
  const [location, setLocation] = useState('');
  const [address, setAddress] = useState('');
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);

  useEffect(() => {
    let timerId;
    if (resendTimer > 0) {
      timerId = setTimeout(() => setResendTimer(resendTimer - 1), 1000);
    }
    return () => clearTimeout(timerId);
  }, [resendTimer]);

  const resetFormState = () => {
    setOtpSent(false);
    setOtp('');
    setOtpError('');
    setResendTimer(0);
  };

  const handleMarketClick = (market) => {
    setActiveMarket(market);
    setActiveSubMarket(marketData[market].subMarkets[0]);
    setSelectedPackage(null);
    setCurrentStep(1); // Go back to step 1 if market changes
    setIsOtpVerified(false);
  };

  const handleSelectPackage = (packageName) => {
    setSelectedPackage(prev => prev === packageName ? null : packageName);
  };

  const goToStep = (step) => {
    setCurrentStep(step);
  };

  const handleSendOtp = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (contactMethod === 'Email' && !emailRegex.test(email)) {
      alert("Please enter a valid email address.");
      return;
    }
    if (contactMethod === 'Mobile' && mobile.length < 10) {
      alert("Please enter a valid 10-digit mobile number.");
      return;
    }
    try {
      if(contactMethod === 'Email') {
        await axios.post('http://localhost:5000/api/send-otp', { email });
        alert("An OTP has been sent to your email.");
      } else {
        await axios.post('http://localhost:5000/api/send-sms-otp', { mobile });
        alert("An OTP has been sent to your mobile.");
      }
      setOtpSent(true);
      setResendTimer(30);
      setOtpError('');
    } catch (error) {
      console.error("Failed to send OTP", error);
      alert("There was an error sending the OTP. Please try again.");
    }
  };

  const handleVerifyOtp = async () => {
    if (otp.length < 4) {
      setOtpError("Please enter a valid 4-digit OTP.");
      return;
    }
    try {
      const identifier = contactMethod === 'Email' ? email : mobile;
      await axios.post('http://localhost:5000/api/verify-otp', { email: identifier, otp: otp });
      setOtpError('');
      alert("OTP Verified Successfully!");
      setIsOtpVerified(true);
    } catch (error) {
      console.error("OTP Verification failed", error);
      setOtpError("Invalid OTP. Please try again.");
    }
  };

  const handleSubmitSignup = async (event) => {
    event.preventDefault();
    if (!fullName || !companyName || !companyType || !location || !address) {
      alert("Please fill in all required fields.");
      return;
    }
    if (!termsAccepted) {
      alert("You must accept the Terms & Conditions and Privacy Policy.");
      return;
    }

    const signupData = {
      market: activeMarket,
      subMarket: activeSubMarket,
      packageName: selectedPackage,
      contactMethod: contactMethod,
      contactValue: contactMethod === 'Email' ? email : mobile,
      fullName: fullName,
      jobTitle: jobTitle,
      companyName: companyName,
      companyType: companyType,
      location: location,
      address: address
    };

    try {
      await axios.post('http://localhost:5000/api/submit-signup', signupData);
      goToStep(3); // Proceed to the final "Thank You" step
    } catch (error) {
      console.error("Signup submission failed", error);
      alert("There was an error submitting your details. Please try again.");
    }
  };

  return (
    <div className="signup-container">
      <header className="signup-header">
        <div className="header-left">
          <button className="hamburger-btn">&#9776;</button>
          <Link to="/" className="logo-link">
            <div className="logo">CRISHI</div>
          </Link>
          <span className="header-separator">|</span>
          <div className="signup-title">Signup</div>
        </div>
        <a href="/" className="support-link">Support</a>
      </header>

      <main className="signup-main">
        <div className="progress-bar">
          <div className={`step ${currentStep >= 1 ? 'active' : ''}`}><span>1</span><div className="step-label">Select Markets & Package</div></div>
          <div className={`step ${currentStep >= 2 ? 'active' : ''}`}><span>2</span><div className="step-label">Details</div></div>
          <div className={`step ${currentStep >= 3 ? 'active' : ''}`}><span>3</span><div className="step-label">Payment</div></div>
        </div>

        {currentStep === 1 && (
          <>
            <div className="market-selection-wrapper">
              <div className="market-selection">
                <div className="tabs-container-main">
                  <h2>Select your markets</h2>
                  <div className="market-tabs">
                    {Object.keys(marketData).map(market => (<button key={market} onClick={() => handleMarketClick(market)} className={activeMarket === market ? 'active' : ''}>{market}</button>))}
                  </div>
                </div>
                <Link to="/request-demo">
                    <button className="request-demo-btn">Request a Demo</button>
                </Link>
              </div>
              <div className="sub-market-tabs">
                {marketData[activeMarket].subMarkets.map(subMarket => (<button key={subMarket} onClick={() => setActiveSubMarket(subMarket)} className={activeSubMarket === subMarket ? 'active' : ''}>{subMarket}</button>))}
              </div>
            </div>
            <div className="package-selection">
              <h3>Select the package you need for each market</h3>
              <div className="packages-grid">
                {Object.entries(marketData[activeMarket].packages).map(([name, features]) => (
                  <div key={name} className={`package-card ${selectedPackage === name ? 'selected' : ''}`}>
                    <div className="package-content">
                      <h4>{name}</h4>
                      <ul>{features.map((feature, index) => <li key={index}><FaCheck className="check-icon" /> {feature}</li>)}</ul>
                    </div>
                    <div className="package-pricing">
                      <p className="price-label">On Request</p>
                      <button className={`select-btn ${selectedPackage === name ? 'selected' : ''}`} onClick={() => handleSelectPackage(name)}>{selectedPackage === name ? 'Selected' : 'Select'}</button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {selectedPackage && (
              <div className="price-summary-section">
                <table className="price-summary-table">
                  <thead><tr><th>Particulars</th><th>Price</th></tr></thead>
                  <tbody>
                    <tr><td><strong>Selected Package(s)</strong><br /><span>{selectedPackage}</span></td><td>Price on Request</td></tr>
                    <tr><td>Add 18% GST</td><td>N/A</td></tr>
                  </tbody>
                  <tfoot><tr><td>Total Amount</td><td>Price on Request</td></tr></tfoot>
                </table>
                <div className="proceed-container">
                  <button className="proceed-btn" onClick={() => goToStep(2)}>Proceed to details <FiArrowRight /></button>
                </div>
              </div>
            )}
          </>
        )}
        
        {currentStep === 2 && (
          <form onSubmit={handleSubmitSignup} className="details-layout">
            <div className="price-summary-static">
              <table className="price-summary-table">
                <thead><tr><th>Particulars</th><th>Price</th></tr></thead>
                <tbody>
                  <tr><td><strong>Selected Package(s)</strong><br /><span>{selectedPackage}</span></td><td>Price on Request</td></tr>
                  <tr><td>Add 18% GST</td><td>N/A</td></tr>
                </tbody>
                <tfoot><tr><td>Total Amount</td><td>Price on Request</td></tr></tfoot>
              </table>
            </div>
            <div className="details-form-container">
              {!isOtpVerified ? (
                <>
                  <div className="form-content">
                    <h4>Primary Account</h4>
                    <div className="contact-method-selector">
                      <label><input type="radio" name="contactMethod" value="Email" checked={contactMethod === 'Email'} onChange={() => { setContactMethod('Email'); resetFormState(); }} /> Email</label>
                      {/* <label><input type="radio" name="contactMethod" value="Mobile" checked={contactMethod === 'Mobile'} onChange={() => { setContactMethod('Mobile'); resetFormState(); }} /> Mobile</label> */}
                    </div>
                    <div className="form-group">
                      <label htmlFor={contactMethod.toLowerCase()}>{contactMethod === 'Email' ? 'E-mail*' : 'Mobile*'}</label>
                      <div className="input-with-button">
                        <input type={contactMethod === 'Email' ? 'email' : 'tel'} id={contactMethod.toLowerCase()} value={contactMethod === 'Email' ? email : mobile} onChange={(e) => contactMethod === 'Email' ? setEmail(e.target.value) : setMobile(e.target.value.replace(/[^0-9]/g, ''))} placeholder={contactMethod === 'Email' ? 'abc@gmail.com' : '9876543210'} />
                        {!otpSent && <button type="button" className="otp-btn" onClick={handleSendOtp}>Send OTP</button>}
                      </div>
                    </div>
                    {otpSent && (
                      <>
                        <div className="form-group otp-group">
                          <label htmlFor="otp">Enter OTP</label>
                          <input type="text" id="otp" value={otp} onChange={(e) => setOtp(e.target.value.replace(/[^0-9]/g, ''))} maxLength="4" />
                          {otpError && <p className="otp-error">{otpError}</p>}
                        </div>
                        <div className="resend-otp-container">
                          {resendTimer > 0 ? (<span>Resend OTP in {resendTimer}s</span>) : (<button type="button" className="resend-btn" onClick={handleSendOtp}>Resend OTP</button>)}
                        </div>
                      </>
                    )}
                  </div>
                  <div className="form-navigation">
                    <button type="button" className="back-arrow-inline" onClick={() => goToStep(1)}><FaArrowLeft /></button>
                    {otpSent && <button type="button" className="next-btn" onClick={handleVerifyOtp}>Verify</button>}
                  </div>
                </>
              ) : (
                <>
                  <div className="form-content">
                    <h4>Primary Account General Information</h4>
                    <div className="form-group"><label>Name *</label><input type="text" value={fullName} onChange={e => setFullName(e.target.value)} required /></div>
                    <div className="form-group"><label>Job Title *</label><input type="text" value={jobTitle} onChange={e => setJobTitle(e.target.value)} required /></div>
                    <div className="form-group"><label>Company Name *</label><input type="text" value={companyName} onChange={e => setCompanyName(e.target.value)} required /></div>
                    <div className="form-group"><label>Company Type *</label>
                      <select value={companyType} onChange={e => setCompanyType(e.target.value)} required><option value="">--Please choose an option--</option><option value="Farming">Farming</option><option value="Trading">Trading</option><option value="Processing">Processing</option><option value="Logistics">Logistics</option></select>
                    </div>
                    <h4>Primary Account Address Information</h4>
                    <div className="form-group"><label>Location *</label><input type="text" value={location} onChange={e => setLocation(e.target.value)} required /></div>
                    <div className="form-group"><label>Address *</label><textarea value={address} onChange={e => setAddress(e.target.value)} required></textarea></div>
                    <div className="terms-checkbox">
                      <input type="checkbox" id="terms" checked={termsAccepted} onChange={e => setTermsAccepted(e.target.checked)} />
                      <label htmlFor="terms">I have read and accepted the Terms & Conditions and Privacy Policy.</label>
                    </div>
                  </div>
                  <div className="form-navigation">
                    <button type="button" className="back-arrow-inline" onClick={() => setIsOtpVerified(false)}><FaArrowLeft /></button>
                    <button type="submit" className="proceed-btn">Proceed</button>
                  </div>
                </>
              )}
            </div>
          </form>
        )}

        {currentStep === 3 && (
          <div className="completion-message-container">
            <h2>Thank You!</h2>
            <p>Your details have been submitted successfully. Our team will contact you soon.</p>
          </div>
        )}
      </main>
    </div>
  );
};

export default Signup;
